var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app", class: { active: !_vm.sp }, attrs: { id: "app" } },
    [
      _c(
        "keep-alive",
        [_vm.$route.meta.keepAlive ? _c("router-view") : _vm._e()],
        1
      ),
      _vm._v(" "),
      !_vm.$route.meta.keepAlive ? _c("router-view") : _vm._e(),
      _vm._v(" "),
      _vm.show
        ? _c("div", {
            staticClass: "messageIcon",
            on: {
              click: function($event) {
                _vm.toDetail()
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.show2
        ? _c("div", {
            staticClass: "messageIcon2",
            on: {
              click: function($event) {
                _vm.toDetail2()
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.xxStatus
        ? _c("div", { staticClass: "maskBox" }, [
            _c("div", { staticClass: "mask" }, [
              _c("div", { staticClass: "maskTop" }, [
                _c("div", { staticClass: "maskTitle" }, [
                  _vm._v(_vm._s(_vm.message))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "btnBox" }, [
                _c(
                  "div",
                  {
                    staticClass: "btn active",
                    on: {
                      click: function($event) {
                        _vm.sure()
                      }
                    }
                  },
                  [_vm._v("确认")]
                )
              ])
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/App.vue
// module id = null
// module chunks = 